import { render, staticRenderFns } from "./HeaderPhone.vue?vue&type=template&id=22670f4d"
import script from "./HeaderPhone.vue?vue&type=script&lang=js"
export * from "./HeaderPhone.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports